export default __webpack_public_path__ + "static/media/black-play.e466974c.svg";